import React, {Component} from 'react'
import {Arc} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {ArcElement as ArcElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: ArcElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class ArcElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Arc
                opacity={element.opacity}
                angle={element.angle}
                innerRadius={element.innerRadius}
                outerRadius={element.outerRadius}
                fill={element.fill}
                strokeWidth={element.strokeWidth}
                strokeScaleEnabled={false}
                id={element.id}
                key={element.id}
                draggable={draggable}
                stroke={element.stroke}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
